import React, { useEffect, useState } from 'react'
import '../assets/css/recipes.css'
import '../assets/css/style.css'
import Navbar from '../components/Navbar'
import AllRecipes from '../components/AllRecipes'
import Footer from '../components/Footer'
import Greeting from '../components/Greeting'

import image from '../assets/images/chef5.jpg'
import { useParams } from 'react-router-dom'
import Empty from '../components/Empty'
import Loading from '../components/Loading'

export default function Recipes(props) {
  const [recipes, setRecipes] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  const {id} = useParams();

  useEffect(()=>{
    setRecipes([]);
  },[props.active]);

  const fetchRecipes = (category) => {
    fetch(`https://lazy-chef-api.vercel.app/recipes/${category}`, {
            credentials: 'include'
        })
      .then((res) => res.json())
      .then((data) => {
        setRecipes((prev) => [...prev, ...data]);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };

  const fetchSearchRecipes = () => {
    fetch(`https://lazy-chef-api.vercel.app/search/recipes/${id}`, {
            credentials: 'include'
        })
      .then((res) => res.json())
      .then((data) => {
        setRecipes((prev) => [...prev, ...data]);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };

  const fetchSearchExpertRecipes = () => {
    fetch(`https://lazy-chef-api.vercel.app/expert/recipes/${id}`, {
            credentials: 'include'
        })
      .then((res) => res.json())
      .then((data) => {
        
        setRecipes((prev) => [...prev, ...data]);
        setLoading(false);
      })
      .catch((err) => console.log(err));
  };

  useEffect(() => {
    setLoading(true);
    const categoryMap = {
      Food: 'random',
      Appetizers: 'appetizer',
      'Non-Veg': 'meat',
      Drinks: 'drink',
      Desserts: 'dessert',
      'Main Courses': 'mainDish',
      Cereals: 'cereal'
    };

    if (categoryMap[props.active]) {
      fetchRecipes(categoryMap[props.active]);
    }
    else if(props.active === 'Search'){
      fetchSearchRecipes();
    }
    else if(props.active === 'Expert Food'){
      fetchSearchExpertRecipes()
    }
  }, [props.active, page]);



  const handleInfiniteScroll = async () => {
    try{
      if(window.innerHeight + document.documentElement.scrollTop + 1 >= document.documentElement.scrollHeight){
        setLoading(true);
        setPage((prev) => prev + 1);
        window.scrollBy(0,-100)
      } 
    }catch(error){
      console.log(error)
    }
  }

  useEffect(() => {
    
    window.addEventListener('scroll', handleInfiniteScroll);
    return () => window.removeEventListener('scroll', handleInfiniteScroll);
  }, []) 

  return (
    <div className='AllRecipesBody'>
        <Navbar active={props.open} open={props.active}/>
        <Greeting  image={image} start={"Hey, it's"} mid={' Vishal ! '} end={'Get Ready to Satisfy Your Taste Buds with My All-Time Favorite '} cat={`${props.active}!`} />
              {loading ? (
        <Loading />
      ) : 
        recipes && recipes.length > 0 ? (
          <div className='RecipePadding'>
            <AllRecipes data={recipes} />
          </div>
        ) : (
          <Empty />
        )
      }
        <Footer/>
    </div>
  )
}
